import { DateUtilsService } from '@sdbn/common';
import { Component, OnInit } from '@angular/core';
import { AppFrameContextService, CommonBrowserStorageService, AppServerAPI } from '@sdbn/common';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { VisitHistory, VisitHistorySelection } from '../export-visitor-log.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';

@Component({
    selector: 'app-export-visitor-log',
    templateUrl: './export-visitor-log.component.html',
    styleUrls: ['./export-visitor-log.component.scss'],
    standalone: false
})
export class ExportVisitorLogComponent implements OnInit {

  COMPONENT_ID = 'export-visit-history';

  SELECTION_STORAGE_KEY = 'selection';

  columnsToDisplay = [
    'createdAt',
    'dayOfWeek',
    'company',
    'name',
    'arrivedAt',
    'allDay',
    'visitedPerson',
    'instructionsDone',
    'instructionFinish',
    'entranceAllowedWithoutGuide',
    'phone',
    'entranceAllowedByCar',
    'numberPlate',
    'chip',
    'chipNumber',
    'terminalRegistration',
    'access',
    'leave',
    'accessGuidedBy',
    'leaveGuidedBy',
    'filler'
  ];

  dataSource: MatTableDataSource<VisitHistory> = new MatTableDataSource(new Array<VisitHistory>());

  selection = new VisitHistorySelection();//this.form.value.dateFrom, this.form.value.dateUntil, 200);

  formGroup = new FormGroup({
    dateFrom: new FormControl(null, []),
    dateUntil: new FormControl(null, []),
    query: new FormControl(null, [])
  });

  constructor(
    private appServerAPI: AppServerAPI,
    private dateUtils: DateUtilsService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private appFrameContextService: AppFrameContextService
  ) {

  }

  ngOnInit(): void {

    this.loadSelectionFromStorage();

    this.formGroup.valueChanges.subscribe(value => {

      this.selection.dateFrom  = this.dateUtils.convertDateToDatePartTimestamp(value.dateFrom);
      this.selection.dateUntil  = this.dateUtils.convertDateToDatePartTimestamp(value.dateUntil);
      this.selection.query  = value.query;

      this.writeSelectionToStorage();

    });

  }

  showDetails() {

    const url = `/client/visit/visit-history/search`;
    this.appServerAPI.execute<Array<any>>(url, this.selection).subscribe(result => {

      let data = new Array<VisitHistory>();
      for (let item of result) {
        data.push(new VisitHistory(item));
      }
      this.dataSource.data = data;

    });

  }

  createExcel() {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'export-visit-log');

    // keep focus in current window
    window.focus();


    const url = `/client/visit/visit-history/create-excel`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, this.selection).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  private loadSelectionFromStorage() {
    let storedSelection = this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value.key, this.COMPONENT_ID, this.SELECTION_STORAGE_KEY);
    if (storedSelection != null) {
      const selectionObject = JSON.parse(storedSelection);
      this.selection.dateFrom = selectionObject.dateFrom;
      this.selection.dateUntil = selectionObject.dateUntil;
      this.selection.query = selectionObject.query;

      this.formGroup.patchValue({

        dateFrom: this.dateUtils.parseDateFromDatePartTimestamp(this.selection.dateFrom),
        dateUntil: this.dateUtils.parseDateFromDatePartTimestamp(this.selection.dateUntil),
        query: this.selection.query

      });
    }
  }

  private writeSelectionToStorage() {
    this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value.key, this.COMPONENT_ID, this.SELECTION_STORAGE_KEY, JSON.stringify(this.selection));
  }

}
